import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { withStyles } from '@app/components/styles'
import {
  restoreActionInfo,
  saveActionDelay,
  saveActionDelayDescription,
  saveActionDeviceStateInfo,
  saveActionDuration,
  saveActionDurationDescription,
  saveActionDurationValueAfter,
  saveActionStateDescription,
  saveDurationValueAfterActionColorType,
  saveInitialActionInfo,
} from '@app/actions/scenes/currentSceneCreating'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectGroupColorActionHue
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateAction/GroupActions/SelectGroupColorActionHue/SelectGroupColorActionHue'
import SelectGroupColorActionHueIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateAction/GroupActions/SelectGroupColorActionHue/SelectGroupColorActionHue'
import { withAccessDenied, withNotifications, withRouter } from '@app/hocs'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectGroupColorActionHueIOS) : withStyles(SelectGroupColorActionHue)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const {
    currentAction: {
      colorType,
      actionDeviceNumber,
    },
    isChangeActionStateMode,
    isChangeActionMode,
    isEditActionMode,
  } = state.scenes.currentSceneCreating
  return {
    actionDeviceNumber,
    colorType,
    isChangeActionStateMode,
    isChangeActionMode,
    isMobile,
    path,
    isEditActionMode,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  saveActionStateDescription,
  saveActionDeviceStateInfo,
  saveInitialActionInfo,
  restoreActionInfo,
  saveActionDelay,
  saveActionDelayDescription,
  saveActionDuration,
  saveActionDurationDescription,
  saveActionDurationValueAfter,
  saveDurationValueAfterActionColorType,
  notifications: syncNotifications.sync,
}, dispatch)

enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectGroupColorActionHueEnhanced = enhance

export default withRouter(SelectGroupColorActionHueEnhanced)
